module.exports = __webpack_public_path__ + "media/images/icons/filled/info-circle-b3c88d61d10a6f0e7e1a93d92880a7c6.svg";